import VueTk from '@moke/vue-tk'
import Vue from 'vue'
import router from '../router/index.js'
import store from '../store'
const auth = [{
  match: '*',
  except: [
    '/login',
    '/register',
    '/helpDetail'
  ],
  handler: function (route, next) {
    if (store.state.login) {
      next(true)
    } else {
      let url = '/login?backUrl=' + window.btoa(route.fullPath)
      next(url)
    }
  },
  fallbackUrl: '/login'
}, {
  match: '*',
  except: [
    '/login',
    '/register',
    '/helpDetail',
    '/linkWechat'
  ],
  handler: function (route, next) {
    if (!store.state.user || !store.state.user.openid) next(false)
    next(true)
  },
  fallbackUrl: '/linkWechat'
}, {
  match: '*',
  except: [
    '/login',
    '/register',
    '/helpDetail',
    '/linkWechat',
    '/profile'
  ],
  handler: function (route, next) {
    if (store.getters.isAdmin && !store.state.user.phone) {
      Vue.prototype.$tkGlobal.alert.show('你需要设置一个手机号')
      next(false)
    } else {
      next(true)
    }
  },
  fallbackUrl: '/profile'
}, {
  match: [/\/attendance\/.+/],
  except: [],
  handler: function (route, next) {
    next(store.getters.isMaster)
  }
}, {
  match: [
    '/login',
    '/register',
  ],
  except: [],
  handler: function (route, next) {
    if (store.state.login) {
      next('/')
    } else {
      next(true)
    }
  },
}]
VueTk.tkRouterAuth.init(auth, router)
